module.exports = __webpack_public_path__ + "static/media/bg-timeline-mobile.ed98c8c8.jpg";